// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","nav":"App_nav__Yz+gE","link":"App_link__kpF6Q"};